import $ from 'jquery';

$(function () {
  $(window).resize(tabPaddingRight);

  function tabPaddingRight() {
    const windowWidth = $(window).width();
    const lastText = $('.header__mobile-tabs .header__mobile-tab:last-child');
    const lastTextWidth = lastText.width();
    const padding = 21;

    const paddingRight = windowWidth - lastTextWidth - padding;

    lastText.css('padding-right', paddingRight);
  }

  tabPaddingRight();
});


$(function animateMobileTabs() {
  const mobileTabsContainer = $('.header__mobile-tabs-scrollable');
  const tabs = mobileTabsContainer.find('.header__mobile-tab');

  tabs.click(function () {
    const tab = $(this);
    const left = tab.position().left;

    mobileTabsContainer.animate({ scrollLeft: left }, 300);
    tabs.removeClass('active');
    tab.addClass('active');
  });
});

$(function initializeFirstTab() {
  const mobileTabsContainer = $('.header__mobile-tabs-scrollable');
  const tab = $getCurrentTab();
  const left = tab.position().left;
  mobileTabsContainer.scrollLeft(left);

  tab.addClass('active');

  function $getCurrentTab() {
    let tab = $(getCurrentTabClass());
    if (tab.length === 0) {
      tab = $('.header__mobile-tab:first');
    }

    return tab;
  }

  function getCurrentTabClass() {
    // Get the page name from the hash.
    // Simply remove the hash from the beginning.
    const tabHash = window.location.hash.split('_')[0];

    let page = tabHash.substr(1);
    switch (tabHash) {
      // Ventajas
      case "#ventajas":
      case "#advantages":
      case "#avantatges":
        page = "ventajas";
        break

      case "#funcionalidades":
      case "#functionalities":
      case "#funcionalitats":
        page = "funcionalidades";
        break;

      case "#infraestructura":
      case "#infrastructure":
        page = "infraestructura";
        break;

      case "#api":
        page = "api";
        break;

      case "#imagenes":
      case "#images":
      case "#imatges":
        page = "imagenes";
        break;

      case "#contacto":
      case "#contact":
      case "#contacte":
        page = "contacto";
        break;

      case "#blog":
        page = "blog";
        break;

      case "#cloud-pros":
        switch (window.location.hash) {
          case "#cloud-pros_contacto":
          case "#cloud-pros_contact":
          case "#cloud-pros_contacte":
            page = "contacto";
            break;

          default:
            page = "cloud-pros";
            break;
        }

        break;
    }

    return `.js-header__mobile-tab-${page}`;
  }

  $(window).on('hashchange', function () {
    const tab = $getCurrentTab();
    const left = tab.position().left;
    mobileTabsContainer.scrollLeft(left);
    mobileTabsContainer.find('.header__mobile-tab').removeClass('active');

    tab.addClass('active');
  });
});